import { getCoreSonarObjectsContextSlice } from './get';
import { patchCoreSonarObjectsContextSlice } from './patch';

export const {
	requestGetCoreSonarObjectsContext,
	resetGetCoreSonarObjectsContext
} = getCoreSonarObjectsContextSlice.asyncActionCreators;

export const {
	requestPatchCoreSonarObjectsContext,
	resetPatchCoreSonarObjectsContext
} = patchCoreSonarObjectsContextSlice.asyncActionCreators;
